<div class="row">
  <div *ngFor="let option of options" class="col-lg-4 mb-3">
    <div
      class="image-select pointer-cursor {{ selectedSelectItem?.value == option.value ? 'selected' : '' }}"
      (click)="onItemClick(option)">
      <img src="{{ option.imagePath  | fileDownloadPath }}" alt="scheme" (load)="imageLoadedEvent($event)" (error)="imageLoadFailedEvent($event)">
      <div class="fs-1 text-center loading-icon"><i class="bi bi-sun fw-bold spinner"></i></div>
      <div class="text-center failed-icon"><i class="bi bi-image fw-bold"></i></div>
      <h5 class="fs-7 pt-2 px-3">{{ option.title }}</h5>
      <p class="px-3 fs-8 line-clamp-3">
        {{ option?.description ?? '' | truncate : 160 }}</p>
    </div>
  </div>
</div>
